import { c as _c } from "react/compiler-runtime";
import { PasswordCardPropertiesType } from "@website/widget/login/components/password-card/password-card.types";
import { AuthByPasswordService } from "@website/widget/login/services/auth-by-password";
import { AuthRequestOtpService } from "@website/widget/login/services/auth-request-otp";
import { ResetPasswordRequestOtpService } from "@website/widget/login/services/reset-password-request-otp";
import { getLoginErrorMessage, isPhoneNumberValid } from "@website/widget/login/utils";
import { useState } from "react";
export const usePasswordCard = properties => {
  const $ = _c(26);
  const {
    userData,
    setStep,
    setUserData,
    onEndAuth
  } = properties;
  const [isLoadingPassword, setIsLoadingPassword] = useState(false);
  const [isLoadingOtp, setIsLoadingOtp] = useState(false);
  const [passwordError, setPasswordError] = useState("");
  const [otpError, setOtpError] = useState("");
  const [password, setPassword] = useState("");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = value => {
      setPassword(value);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const onChangePassword = t0;
  let t1;
  if ($[1] !== onEndAuth || $[2] !== password || $[3] !== setUserData || $[4] !== userData) {
    t1 = async _event => {
      _event.preventDefault();
      if (password) {
        setIsLoadingPassword(true);
        setPasswordError("");
        AuthByPasswordService({
          phoneNumber: userData?.phoneNumber,
          password
        }).then(data => {
          const {
            accessToken,
            refreshToken
          } = data;
          if (accessToken) {
            setUserData({
              ...userData,
              ...data
            });
            onEndAuth?.(accessToken, refreshToken);
          }
        }).catch(error => {
          setPasswordError(getLoginErrorMessage(error));
        }).finally(() => setIsLoadingPassword(false));
      } else {
        setPasswordError("\u0631\u0645\u0632 \u0639\u0628\u0648\u0631 \u062E\u0648\u062F \u0631\u0627 \u0648\u0627\u0631\u062F \u06A9\u0646\u06CC\u062F.");
      }
    };
    $[1] = onEndAuth;
    $[2] = password;
    $[3] = setUserData;
    $[4] = userData;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const onSubmitPassword = t1;
  let t2;
  if ($[6] !== setStep || $[7] !== setUserData || $[8] !== userData) {
    t2 = async () => {
      const {
        phoneNumber
      } = userData;
      if (isPhoneNumberValid(phoneNumber)) {
        setIsLoadingOtp(true);
        setOtpError("");
        AuthRequestOtpService({
          phoneNumber
        }).then(data_0 => {
          setStep("otp");
          setUserData({
            ...userData,
            ...data_0
          });
        }).catch(error_0 => {
          setOtpError(getLoginErrorMessage(error_0));
        }).finally(() => setIsLoadingOtp(false));
      }
    };
    $[6] = setStep;
    $[7] = setUserData;
    $[8] = userData;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const onOtpClick = t2;
  let t3;
  if ($[10] !== setStep || $[11] !== setUserData || $[12] !== userData) {
    t3 = async () => {
      const {
        phoneNumber: phoneNumber_0
      } = userData;
      if (isPhoneNumberValid(phoneNumber_0)) {
        setIsLoadingOtp(true);
        setPasswordError("");
        ResetPasswordRequestOtpService({
          phoneNumber: phoneNumber_0
        }).then(data_1 => {
          setUserData({
            ...userData,
            ...data_1,
            forgotPassword: true
          });
          setStep("otp");
        }).catch(error_1 => {
          setPasswordError(getLoginErrorMessage(error_1));
        }).finally(() => setIsLoadingOtp(false));
      }
    };
    $[10] = setStep;
    $[11] = setUserData;
    $[12] = userData;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  const onClickForgotPassword = t3;
  let t4;
  if ($[14] !== setStep) {
    t4 = () => {
      setStep("phone-number");
    };
    $[14] = setStep;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  const onBackClick = t4;
  let t5;
  if ($[16] !== isLoadingOtp || $[17] !== isLoadingPassword || $[18] !== onBackClick || $[19] !== onClickForgotPassword || $[20] !== onOtpClick || $[21] !== onSubmitPassword || $[22] !== otpError || $[23] !== password || $[24] !== passwordError) {
    t5 = {
      isLoadingPassword,
      isLoadingOtp,
      password,
      onChangePassword,
      onSubmitPassword,
      onOtpClick,
      passwordError,
      otpError,
      onClickForgotPassword,
      onBackClick
    };
    $[16] = isLoadingOtp;
    $[17] = isLoadingPassword;
    $[18] = onBackClick;
    $[19] = onClickForgotPassword;
    $[20] = onOtpClick;
    $[21] = onSubmitPassword;
    $[22] = otpError;
    $[23] = password;
    $[24] = passwordError;
    $[25] = t5;
  } else {
    t5 = $[25];
  }
  return t5;
};